class GaiaLoveScripts {
  constructor() {
    (function ($) {
      "use strict";

      const isMobile = {
        Android: function () {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
          return (
            navigator.userAgent.match(/IEMobile/i) ||
            navigator.userAgent.match(/WPDesktop/i)
          );
        },
        any: function () {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          );
        },
      };

      function tostifyCustomClose(el) {
        const parent = el.closest(".toastify");
        const close = parent.querySelector(".toast-close");

        close.click();
      }

      function toastModel(model, title, message) {
        switch (model) {
          case "success":
            return `
                <div class="flex p-3">
                    <p class="text-base font-semibold text-white dark:text-white m-0">${message}</p>
                    <div class="ms-auto">
                        <button onclick="tostifyCustomClose(this)" type="button" class="inline-flex shrink-0 justify-center items-center size-5 rounded-lg text-white opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100 dark:text-white" aria-label="Close">
                            <span class="sr-only">Close</span>
                            <svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
                        </button>
                    </div>
                </div>
              `;
        }
        return;
      }

      $("#afiliado_gerar_cupom").on("submit", function (e) {
        e.preventDefault();
        const $form = $("#afiliado_gerar_cupom");
        const cupom = $(this).find('[name="codigo_cupom"]').val();
        const security = $(this).find('[name="gaia_love_security"]').val();

        if (!cupom || (cupom && cupom.length < 3)) {
          $("#gaia-afiliado-modal").html(
            $("#gaia-afiliado-modal").html().replace("{titulo}", "Atenção")
          );
          $("#gaia-afiliado-modal").html(
            $("#gaia-afiliado-modal")
              .html()
              .replace("{texto}", t("affiliates.coupon_min_length"))
          );
          // $('#gaia-afiliado-modal-label').text('Atenção');
          // $('#gaia-afiliado-modal-text').text('O Cupom deve ter no mínimo 3 caracteres');
          HSOverlay.getInstance("#gaia-afiliado-modal", true).element.open();
          return;
        }
        if (cupom && cupom.length > 10) {
          $("#gaia-afiliado-modal #gaia-afiliado-modal-label").html("Atenção");
          $("#gaia-afiliado-modal #gaia-afiliado-modal-text").html(
            t("affiliates.coupon_max_length")
          );
          HSOverlay.getInstance("#gaia-afiliado-modal", true).element.open();
          return;
        }

        $form.toggleClass("loading");

        $.ajax({
          url: gaiaCustomData.ajax_url,
          type: "POST",
          data: {
            action: "gaia_love_criar_cupom",
            security: security,
            cupom: cupom,
          },
          success: function (response) {
            console.log(response);

            if (response.success) {
              if (
                response.cupons_html &&
                !$(".box-cupons .empty").hasClass("hidden")
              ) {
                console.log("Nenhum cupom existente na página");
                $(".box-cupons .empty").addClass("hidden");
                $("#cupons_table").addClass("loading");
                $(".box-cupons .no-empty").removeClass("hidden");

                setTimeout(() => {
                  console.log("Inserindo cupons");
                  $("#cupons_table tbody").html(response.cupons_html);
                  $("#cupons_table").removeClass("loading");
                }, 2000);

                $form.removeClass("loading");
              }

              if (
                response.cupons_html &&
                $(".box-cupons .empty").hasClass("hidden")
              ) {
                console.log("Cupons existentes na página");
                $("#cupons_table").addClass("loading");

                setTimeout(() => {
                  console.log("Inserindo novos cupons");
                  $("#cupons_table tbody").html(response.cupons_html);
                  $("#cupons_table").removeClass("loading");
                }, 2000);

                $form.removeClass("loading");
              }

              const responseTemplate = toastModel(
                "success",
                null,
                t("affiliates.coupon_created_successfully")
              );
              Toastify({
                text: responseTemplate,
                className:
                  "hs-toastify-on:opacity-100 opacity-0 fixed -bottom-[150px] z-[90] transition-all duration-300 w-[320px] md:w-[400px] max-w-full bg-none bg-emerald-500 text-base text-white border border-emerald-400 rounded-xl shadow-lg [&>.toast-close]:hidden dark:bg-emerald-800 dark:border-emerald-700 dark:white",
                duration: 3000,
                close: true,
                escapeMarkup: false,
                gravity: "bottom",
                position: "center",
              }).showToast();
            }

            if (!response.success) {
              $("#gaia-afiliado-modal #gaia-afiliado-modal-label").html(
                "Error"
              );
              $("#gaia-afiliado-modal #gaia-afiliado-modal-text").html(
                response.message
              );
              HSOverlay.getInstance(
                "#gaia-afiliado-modal",
                true
              ).element.open();
              $form.removeClass("loading");
            }
          },
        });
      });

      $(document).on("click", ".gaia_delete_cupom", function (e) {
        e.preventDefault();
        const $btn = $(this);
        const cupom = $btn.data("cupom");
        const security = $(
          '#cupons_table [name="gaia_love_security_delete"]'
        ).val();

        if (!cupom) {
          $("#gaia-afiliado-modal").html(
            $("#gaia-afiliado-modal").html().replace("{titulo}", "Error")
          );
          $("#gaia-afiliado-modal").html(
            $("#gaia-afiliado-modal")
              .html()
              .replace("{texto}", t("affiliates.invalid_coupon"))
          );
          HSOverlay.getInstance("#gaia-afiliado-modal", true).element.open();
          return;
        }

        console.log(cupom);

        $("#cupons_table").addClass("loading");

        $.ajax({
          url: gaiaCustomData.ajax_url,
          type: "POST",
          data: {
            action: "gaia_love_excluir_cupom",
            security: security,
            cupom: cupom,
          },
          success: function (response) {
            console.log(response);

            if (response.success) {
              if (response.cupons_html) {
                setTimeout(() => {
                  $("#cupons_table tbody").html(response.cupons_html);
                  $("#cupons_table").toggleClass("loading");
                }, 2000);
              } else {
                $(".box-cupons .empty").removeClass("hidden");
                $(".box-cupons .no-empty").addClass("hidden");
              }

              const responseTemplate = toastModel(
                "success",
                null,
                t("affiliates.coupon_removed_successfully")
              );
              Toastify({
                text: responseTemplate,
                className:
                  "hs-toastify-on:opacity-100 opacity-0 fixed -bottom-[150px] z-[90] transition-all duration-300 w-[320px] md:w-[400px] max-w-full bg-none bg-emerald-500 text-base text-white border border-emerald-400 rounded-xl shadow-lg [&>.toast-close]:hidden dark:bg-emerald-800 dark:border-emerald-700 dark:white",
                duration: 3000,
                close: true,
                escapeMarkup: false,
                gravity: "bottom",
                position: "center",
              }).showToast();
            }

            if (!response.success) {
              $("#gaia-afiliado-modal").html(
                $("#gaia-afiliado-modal").html().replace("{titulo}", "Error")
              );
              $("#gaia-afiliado-modal").html(
                $("#gaia-afiliado-modal")
                  .html()
                  .replace("{texto}", response.message)
              );
              HSOverlay.getInstance(
                "#gaia-afiliado-modal",
                true
              ).element.open();
              $("#cupons_table").toggleClass("loading");
            }
          },
        });
      });

      $(document).on("click", ".gaia_love_credit_checkout", function (e) {
        e.preventDefault();
        const $btn = $(this);
        const security = $('#afiliado [name="gaia_love_security_apply"]').val();

        $btn.addClass("loading");

        $.ajax({
          url: gaiaCustomData.ajax_url,
          type: "POST",
          data: {
            action: "aplicar_desconto_comissao",
            security: security,
          },
          success: function (response) {
            console.log(response);

            if (response.success) {
              if (response.status == "applied") {
                const responseTemplate = toastModel(
                  "success",
                  null,
                  t("affiliates.credit_applied_to_cart")
                );
                Toastify({
                  text: responseTemplate,
                  className:
                    "hs-toastify-on:opacity-100 opacity-0 fixed -bottom-[150px] z-[90] transition-all duration-300 w-[320px] md:w-[400px] max-w-full bg-none bg-emerald-500 text-base text-white border border-emerald-400 rounded-xl shadow-lg [&>.toast-close]:hidden dark:bg-emerald-800 dark:border-emerald-700 dark:white",
                  duration: 3000,
                  close: true,
                  escapeMarkup: false,
                  gravity: "bottom",
                  position: "center",
                }).showToast();
              } else {
                const responseTemplate = toastModel(
                  "success",
                  null,
                  t("affiliates.credit_removed_from_cart")
                );
                Toastify({
                  text: responseTemplate,
                  className:
                    "hs-toastify-on:opacity-100 opacity-0 fixed -bottom-[150px] z-[90] transition-all duration-300 w-[320px] md:w-[400px] max-w-full bg-none bg-emerald-500 text-base text-white border border-emerald-400 rounded-xl shadow-lg [&>.toast-close]:hidden dark:bg-emerald-800 dark:border-emerald-700 dark:white",
                  duration: 3000,
                  close: true,
                  escapeMarkup: false,
                  gravity: "bottom",
                  position: "center",
                }).showToast();
              }

              $("body").trigger("update_checkout");
              $("[name='update_cart']")
                .removeAttr("disabled")
                .attr("aria-disabled", "false")
                .trigger("click");
            }

            if (!response.success) {
              $("#gaia-afiliado-modal").html(
                $("#gaia-afiliado-modal").html().replace("{titulo}", "Error")
              );
              $("#gaia-afiliado-modal").html(
                $("#gaia-afiliado-modal")
                  .html()
                  .replace("{texto}", response.message)
              );
              HSOverlay.getInstance(
                "#gaia-afiliado-modal",
                true
              ).element.open();
            }

            $btn.removeClass("loading");
          },
        });
      });

      // if ($("#seja-afiliado-page").length) {
        // console.log("Seja um Gaia Lover!");
        // const { element } = HSTogglePassword.getInstance(
        //   ".field_show_password",
        //   true
        // );
        // const showBtn = document.querySelectorAll(".show_password");
        // showBtn.addEventListener("click", () => {
        //   element.show();
        // });
      // }

      // Validações e Máscaras
      function formatarParaNumero(valorComMascara) {
        if (!valorComMascara) return 0; // Evita erros em valores vazios

        // Remove os separadores de milhar (pontos)
        let valorSemMilhar = valorComMascara.replace(/\./g, "");

        // Substitui a vírgula decimal por ponto
        let valorFormatado = valorSemMilhar.replace(",", ".");

        // Converte para número
        return parseFloat(valorFormatado);
      }
      // Valor
      var optionsValor = {
        reverse: true,
        onComplete: function (val) {
          $("#gaia-love-valor-paypal").closest(".group").removeClass("invalid");
        },
        onChange: function (val) {
          if (val > 0 && val <= 199) {
            $("#gaia-love-valor-paypal")
              .closest(".group")
              .removeClass("invalid");
          }
        },
      };
      $("input#gaia-love-valor-paypal").mask("#.##0,00", optionsValor);
      $("input#gaia-love-paypal").on("change", function () {
        $(this).closest(".group").removeClass("invalid");
      });
      // END - Validações e Máscaras
      $(document).on("click", ".gaia_love_resgatar_comissao", function (e) {
        e.preventDefault();
        const popupResgate = HSOverlay.getInstance(
          "#gaia-afiliado-regate-modal",
          true
        ).element;
        popupResgate.open();
        return;
      });
      $(document).on("click", ".gaia_love_solicitar_resgate", function (e) {
        e.preventDefault();
        const $btn = $(this);
        const valor = formatarParaNumero($("#gaia-love-valor-paypal").val());
        const paypal = $("#gaia-love-paypal").val();
        const iban = $("#gaia-love-iban").val();
        const security = $(
          '#gaia-afiliado-regate-modal [name="gaia_love_security_resgate"]'
        ).val();

        if (valor == 0) {
          $("#gaia-love-valor-paypal").closest(".group").addClass("invalid");
          $("#gaia-love-valor-paypal")
            .closest(".group")
            .find(".text_validation_error")
            .html(t("affiliates.enter_the_amount_to_be_redeemed"));
          return;
        }

        if (false && valor < 199) {
          $("#gaia-love-valor-paypal").closest(".group").addClass("invalid");
          $("#gaia-love-valor-paypal")
            .closest(".group")
            .find(".text_validation_error")
            .html(t("affiliates.minimum_redeem_amount"));
          return;
        }

        // if (!paypal) {
        //   $("#gaia-love-paypal").closest(".group").addClass("invalid");
        //   $("#gaia-love-paypal")
        //     .closest(".group")
        //     .find(".text_validation_error")
        //     .html(t("affiliates.enter_your_paypal_account_for_redeem"));
        //   return;
        // }
        
        if (!iban) {
          $("#gaia-love-iban").closest(".group").addClass("invalid");
          $("#gaia-love-iban")
            .closest(".group")
            .find(".text_validation_error")
            .html(t("affiliates.enter_your_iban_account_for_redeem"));
          return;
        }

        $btn.addClass("loading");
        $(".gaia_love_resgatar_comissao").addClass("loading");

        $.ajax({
          url: gaiaCustomData.ajax_url,
          type: "POST",
          data: {
            action: "gaia_love_resgate_paypal",
            security: security,
            valor: valor,
            paypal: paypal,
            iban: iban,
          },
          success: function (response) {
            console.log(response);

            if (response.success) {
              const responseTemplate = toastModel(
                "success",
                null,
                t("affiliates.rescue_requested_successfully")
              );

              const popupResgate = HSOverlay.getInstance(
                "#gaia-afiliado-regate-modal",
                true
              ).element;

              setTimeout(() => {
                Toastify({
                  text: responseTemplate,
                  className:
                    "hs-toastify-on:opacity-100 opacity-0 fixed -bottom-[150px] z-[90] transition-all duration-300 w-[320px] md:w-[400px] max-w-full bg-none bg-emerald-500 text-base text-white border border-emerald-400 rounded-xl shadow-lg [&>.toast-close]:hidden dark:bg-emerald-800 dark:border-emerald-700 dark:white",
                  duration: 3000,
                  close: true,
                  escapeMarkup: false,
                  gravity: "bottom",
                  position: "center",
                }).showToast();
                $(".response_resgate_paypal").html(response.html);
                $btn.removeClass("loading");
                popupResgate.close();
              }, 1500);
              return;
            }

            if (!response.success) {
              if (response.field == "valor") {
                $("#gaia-love-valor-paypal")
                  .closest(".group")
                  .addClass("invalid");
                $("#gaia-love-valor-paypal")
                  .closest(".group")
                  .find(".text_validation_error")
                  .html(response.message);
              } else if (response.field == "paypal") {
                $("#gaia-love-paypal").closest(".group").addClass("invalid");
                $("#gaia-love-paypal")
                  .closest(".group")
                  .find(".text_validation_error")
                  .html(response.message);
              } else {
                $("#gaia-afiliado-modal").html(
                  $("#gaia-afiliado-modal").html().replace("{titulo}", "Error")
                );
                $("#gaia-afiliado-modal").html(
                  $("#gaia-afiliado-modal")
                    .html()
                    .replace(
                      "{texto}",
                      response.message
                        ? response.message
                        : t("affiliates.an_internal_error_has_occurred_please_try_again_later")
                    )
                );
                HSOverlay.getInstance(
                  "#gaia-afiliado-modal",
                  true
                ).element.open();
              }
            }

            $btn.removeClass("loading");
            $(".gaia_love_resgatar_comissao").removeClass("loading");
          },
          error: function (xhr, status, error) {
            console.log(xhr);
            console.log(status);
            console.log(error);

            const response = xhr.responseJSON;

            if (!response.success) {
              if (response.field == "valor") {
                $("#gaia-love-valor-paypal")
                  .closest(".group")
                  .addClass("invalid");
                $("#gaia-love-valor-paypal")
                  .closest(".group")
                  .find(".text_validation_error")
                  .html(response.message);
              } else if (response.field == "paypal") {
                $("#gaia-love-paypal").closest(".group").addClass("invalid");
                $("#gaia-love-paypal")
                  .closest(".group")
                  .find(".text_validation_error")
                  .html(response.message);
              } else {
                $("#gaia-afiliado-modal").html(
                  $("#gaia-afiliado-modal").html().replace("{titulo}", "Error")
                );
                $("#gaia-afiliado-modal").html(
                  $("#gaia-afiliado-modal")
                    .html()
                    .replace(
                      "{texto}",
                      response.message
                        ? response.message
                        : t("affiliates.an_internal_error_has_occurred_please_try_again_later")
                    )
                );
                HSOverlay.getInstance(
                  "#gaia-afiliado-modal",
                  true
                ).element.open();
              }
            }

            $btn.removeClass("loading");
            $(".gaia_love_resgatar_comissao").removeClass("loading");
          },
        });
      });

      // CADASTRO
      var optionsCpfCnpj = {
        onKeyPress: function (cpf, ev, el, op) {
          var masks = ["000.000.000-000", "00.000.000/0000-00"];
          $('input[name="cpf_cnpj"]').mask(
            cpf.length > 14 ? masks[1] : masks[0],
            op
          );
        },
      };
      $('input[name="cpf_cnpj"]').length > 11
        ? $('input[name="cpf_cnpj"]').mask("00.000.000/0000-00", optionsCpfCnpj)
        : $('input[name="cpf_cnpj"]').mask("000.000.000-00#", optionsCpfCnpj);
      $("#gaia_love_cadastro input").on("change input", function () {
        $(this).removeClass("invalid");
      });
      $("#gaia_love_cadastro").on("submit", function (e) {
        e.preventDefault();
        const $form = $(this);
        const nome = $form.find('[name="nome"]').val();
        // const cpf_cnpj = $form.find('[name="cpf_cnpj"]').val();
        const telefone = $form.find('[name="telefone"]').val();
        const email = $form.find('[name="email"]').val();
        const instagram = $form.find('[name="instagram"]').val();
        const facebook = $form.find('[name="facebook"]').val();
        const tiktok = $form.find('[name="tiktok"]').val();
        const paypal = $form.find('[name="paypal"]').val();
        const iban = $form.find('[name="iban"]').val();
        const message = $form.find('[name="message"]').val();
        const password = $form.find('[name="password"]').val();
        const confirm_password = $form.find('[name="confirm-password"]').val();
        const pole_gaia = $form.find('[name="pole_gaia"]').is(":checked")
          ? 1
          : 0;
        const security = $form.find('[name="gaia_love_security"]').val();

        if (!nome) {
          console.log("Nome: " + nome);
          $("#gaia-afiliado-modal #gaia-afiliado-modal-label").html(
            t("affiliates.attention")
          );
          $("#gaia-afiliado-modal #gaia-afiliado-modal-text").html(
            t("affiliates.name_is_required")
          );
          $form.find('[name="nome"]').addClass("invalid");
          HSOverlay.getInstance("#gaia-afiliado-modal", true).element.open();
          return;
        }

        if (false && !cpf_cnpj) {
          $("#gaia-afiliado-modal #gaia-afiliado-modal-label").html(
            "Attention"
          );
          $("#gaia-afiliado-modal #gaia-afiliado-modal-text").html(
            "O CPF/CNPJ é obrigatório"
          );
          $form.find('[name="cpf_cnpj"]').addClass("invalid");
          HSOverlay.getInstance("#gaia-afiliado-modal", true).element.open();
          return;
        }

        if (!telefone) {
          $("#gaia-afiliado-modal #gaia-afiliado-modal-label").html(
            t("affiliates.attention")
          );
          $("#gaia-afiliado-modal #gaia-afiliado-modal-text").html(
            t("affiliates.telephone_is_required")
          );
          $form.find('[name="telefone"]').addClass("invalid");
          HSOverlay.getInstance("#gaia-afiliado-modal", true).element.open();
          return;
        }

        if (!email) {
          $("#gaia-afiliado-modal #gaia-afiliado-modal-label").html(
            t("affiliates.attention")
          );
          $("#gaia-afiliado-modal #gaia-afiliado-modal-text").html(
            t("affiliates.email_is_required")
          );
          $form.find('[name="email"]').addClass("invalid");
          HSOverlay.getInstance("#gaia-afiliado-modal", true).element.open();
          return;
        }

        if (password != confirm_password) {
          $("#gaia-afiliado-modal #gaia-afiliado-modal-label").html(
            t("affiliates.attention")
          );
          $("#gaia-afiliado-modal #gaia-afiliado-modal-text").html(
            t("affiliates.passwords_do_not_match")
          );
          //   $form.find('[name="password"]').addClass("invalid");
          $form.find('[name="confirm-password"]').addClass("invalid");
          HSOverlay.getInstance("#gaia-afiliado-modal", true).element.open();
          return;
        }

        $form.addClass("loading");

        $.ajax({
          url: gaiaCustomData.ajax_url,
          type: "POST",
          data: {
            action: "gaia_love_cadastro",
            security: security,
            nome: nome,
            email: email,
            telefone: telefone,
            instagram: instagram,
            facebook: facebook,
            tiktok: tiktok,
            paypal: paypal,
            iban: iban,
            message: message,
            password: password,
            confirm_password: confirm_password,
            pole_gaia: pole_gaia,
          },
          success: function (response) {
            console.log(response);

            if (response.success) {
              if (response.redirect) {
                window.location.replace(response.redirect);
              }
              return;
            }

            if (!response.success) {
              $("#gaia-afiliado-modal #gaia-afiliado-modal-label").html(
                t("affiliates.error")
              );
              $("#gaia-afiliado-modal #gaia-afiliado-modal-text").html(
                response.message
              );
              HSOverlay.getInstance(
                "#gaia-afiliado-modal",
                true
              ).element.open();
            }

            $form.removeClass("loading");
          },
        });
      });
    })(jQuery);
  }
}

export default GaiaLoveScripts;
